import { MapPin, Phone, Mail, MessageCircle, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { buildGeneralWhatsAppLink, getDefaultWhatsAppMessage } from "@/utils/whatsapp";
import { trackClickWhatsApp } from "@/utils/analytics";

export const DASContact = () => {
  const handleWhatsAppClick = () => {
    trackClickWhatsApp('contact');
    window.open(buildGeneralWhatsAppLink(getDefaultWhatsAppMessage()), '_blank');
  };

  return (
    <section id="contact" className="py-12 md:py-20 bg-gray-100">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-black mb-4">
            Standort & Kontakt
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto">
          {/* Map */}
          <div className="h-64 md:h-80 lg:h-96 bg-white rounded-lg overflow-hidden shadow-card order-2 lg:order-1">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2704.819234!2d8.520!3d47.195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDfCsDExJzQyLjAiTiA4wrAzMScxMi4wIkU!5e0!3m2!1sde!2sch!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="DAS Group AG Standort"
            />
          </div>

          {/* Contact Cards */}
          <div className="space-y-3 md:space-y-4 order-1 lg:order-2">
            <Card>
              <CardContent className="p-4 md:p-6">
                <div className="flex items-start gap-3 md:gap-4">
                  <MapPin className="h-5 w-5 md:h-6 md:w-6 text-gold flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-heading font-bold text-base md:text-lg mb-3">Unsere Standorte</h3>
                    <div className="text-gray-700 space-y-3">
                      <div>
                        <p className="font-semibold">Baar (Hauptsitz)</p>
                        <p className="text-sm">
                          Bahnhofstrasse 8B<br />
                          6340 Baar
                        </p>
                      </div>
                      <div>
                        <p className="font-semibold">Ebikon</p>
                        <p className="text-sm">
                          Dorfstrasse 5<br />
                          6030 Ebikon
                        </p>
                      </div>
                      <div>
                        <p className="font-semibold">Kriens</p>
                        <p className="text-sm">
                          Sportweg 5<br />
                          6010 Kriens
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-4 md:p-6">
                <div className="flex items-start gap-3 md:gap-4">
                  <MessageCircle className="h-5 w-5 md:h-6 md:w-6 text-gold flex-shrink-0 mt-1" />
                  <div className="flex-1">
                    <h3 className="font-heading font-bold text-base md:text-lg mb-2">WhatsApp</h3>
                    <Button 
                      onClick={handleWhatsAppClick}
                      className="bg-gold hover:bg-gold-hover text-white font-semibold w-full transition-colors duration-200"
                    >
                      +41 79 708 50 08
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-4 md:p-6">
                <div className="flex items-start gap-3 md:gap-4">
                  <Phone className="h-5 w-5 md:h-6 md:w-6 text-gold flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-heading font-bold text-base md:text-lg mb-1">Telefon</h3>
                    <a href="tel:+41414402223" className="text-gray-700 hover:text-gold">
                      041 440 22 23
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-4 md:p-6">
                <div className="flex items-start gap-3 md:gap-4">
                  <Mail className="h-5 w-5 md:h-6 md:w-6 text-gold flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-heading font-bold text-base md:text-lg mb-1">E-Mail</h3>
                    <a href="mailto:info@dasgroup.ch" className="text-gray-700 hover:text-gold">
                      info@dasgroup.ch
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-4 md:p-6">
                <div className="flex items-start gap-3 md:gap-4">
                  <Clock className="h-5 w-5 md:h-6 md:w-6 text-gold flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-heading font-bold text-base md:text-lg mb-1">Öffnungszeiten</h3>
                    <div className="text-gray-700 text-sm space-y-1">
                      <p>Montag - Freitag: 08:00 - 18:00</p>
                      <p>Samstag: 09:00 - 16:00</p>
                      <p>Sonntag: Nach Vereinbarung</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};
